export default "__VITE_ASSET__491fe8bb__"